<mat-form-field appearance="outline">
  <mat-select  [multiple]="true" (selectionChange)="onChange($event)" [formControl]="itemMultiCtrl" [placeholder]="outlineLabel" #multiSelect>
    <mat-option>
      <ngx-mat-select-search [formControl]="assignFilterCtrl" [placeholderLabel]="'COMMON.SEARCH' | translate" [noEntriesFoundLabel]="'COMMON.NO_DATA_FOUND' | translate"></ngx-mat-select-search>
    </mat-option>

    <mat-option *ngFor="let assign of filteredAssign | async"  [value]="assign">
      {{assign[optionName]}}
    </mat-option>
  </mat-select>
</mat-form-field>
